import { render } from "./OrderList.vue?vue&type=template&id=07885676&scoped=true&bindings={\"list\":\"setup\"}"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=07885676&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-07885676"

export default script